import * as React from 'react'

import { TLanguage } from '~config/locales'
import { createContext } from '~logic/lib/react'

type TLocale = TLanguage['code']

const [Provider, useLocaleCtx] = createContext<TLocale>(`Locale`)

type TProps = RequiredChildren & {
  locale: TLocale
}

/**
 * Currently resolved/selected language locale provider.
 */
export const LocaleProvider: React.FC<TProps> = ({ locale, children }) => {
  return <Provider value={locale}>{children}</Provider>
}

export { useLocaleCtx }
